import { useQuery } from '@tanstack/react-query';
import { authClient } from 'src/services/auth/client';
import { QUERIES } from 'src/utils/react-query';

export type AuditRow = {
  id: string;
  event: string;
  target: Record<string, unknown>;
  createdAt: string;
  actorName: string | null;
  actorEmail: string | null;
};

export function useAuditLog(organizationId: string | null, page: number) {
  return useQuery({
    queryKey: [QUERIES.AUDIT_LOG, organizationId, page],
    enabled: Boolean(organizationId),
    queryFn: async () => {
      // Auth service calls go through the better-auth client fetch: it captured the
      // plain window.fetch at module init, so it stays free of the Sentry trace headers
      // that break the auth CORS preflight on raw fetch (sentry-trace not allow-listed).
      const { data, error } = await authClient.$fetch(`${import.meta.env.VITE_AUTH_URL}/internal/audit-log`, {
        method: 'GET',
        query: { organizationId, page: String(page), limit: '25' },
      });
      if (error) throw new Error(`Audit log request failed: ${error.status ?? error.message}`);
      return data as { data: AuditRow[]; total: number; page: number; limit: number };
    },
  });
}
